<template>
    <svg class="icon" aria-hidden="true">
        <use :xlink:href="iconName"></use>
    </svg>
</template>

<script>
export default {
  name: 'svgIcon',
  props:{
      iconName:{
          type:String,
          default:''
      }
  },
  data () {
    return {
        
    }
  }
}
</script>
<style lang="scss" scoped>
// 阿里svg图标
.icon {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/publicComponents/svgIcon/index.vue